/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const appModals: { [k: string]: LazyModal } = {
  CourseConfirmCloseModal: {
    loadComponent: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-close-modal/course-confirm-close-modal.component'
      ).then(m => m.CourseConfirmCloseModalComponent),
    loadModule: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-close-modal/course-confirm-close-modal.module'
      ).then(m => m.CourseConfirmCloseModalModule),
  },
  CourseConfirmDeleteModal: {
    loadComponent: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-delete-modal/course-confirm-delete-modal.component'
      ).then(m => m.CourseConfirmDeleteModalComponent),
    loadModule: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-delete-modal/course-confirm-delete-modal.module'
      ).then(m => m.CourseConfirmDeleteModalModule),
  },
  CourseConfirmPublishModal: {
    loadComponent: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-publish-modal/course-confirm-publish-modal.component'
      ).then(m => m.CourseConfirmPublishModalComponent),
    loadModule: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-publish-modal/course-confirm-publish-modal.module'
      ).then(m => m.CourseConfirmPublishModalModule),
  },
  CourseConfirmUnpublishModal: {
    loadComponent: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-unpublish-modal/course-confirm-unpublish-modal.component'
      ).then(m => m.CourseConfirmUnpublishModalComponent),
    loadModule: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-unpublish-modal/course-confirm-unpublish-modal.module'
      ).then(m => m.CourseConfirmUnpublishModalModule),
  },
  AiConsultantEmailConfirmationModal: {
    loadComponent: () =>
      import(
        'app/ai-consultant/ai-consultant-email-confirmation-modal/ai-consultant-email-confirmation-modal.component'
      ).then(m => m.AiConsultantEmailConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/ai-consultant/ai-consultant-email-confirmation-modal/ai-consultant-email-confirmation-modal.module'
      ).then(m => m.AiConsultantEmailConfirmationModalModule),
  },
  AssignProjectModal: {
    loadComponent: () =>
      import('app/assign-project-modal/assign-project-modal.component').then(
        m => m.AssignProjectModalComponent,
      ),
    loadModule: () =>
      import('app/assign-project-modal/assign-project-modal.module').then(
        m => m.AssignProjectModalModule,
      ),
  },
  AiServiceConsultationModal: {
    loadComponent: () =>
      import(
        'app/back-to-work/ai-service-consultation-modal/ai-service-consultation-modal.component'
      ).then(m => m.AiServiceConsultationModalComponent),
    loadModule: () =>
      import(
        'app/back-to-work/ai-service-consultation-modal/ai-service-consultation-modal.module'
      ).then(m => m.AiServiceConsultationModalModule),
  },
  BuildYourOwnAgentModal: {
    loadComponent: () =>
      import(
        'app/back-to-work/build-your-own-agent/build-our-own-agent-modal/build-your-own-agent-modal.component'
      ).then(m => m.BuildYourOwnAgentModalComponent),
    loadModule: () =>
      import(
        'app/back-to-work/build-your-own-agent/build-our-own-agent-modal/build-your-own-agent-modal.module'
      ).then(m => m.BuildYourOwnAgentModalModule),
  },
  LaunchDeckCardModal: {
    loadComponent: () =>
      import(
        'app/back-to-work/launch-deck/launch-deck-card-modal/launch-deck-card-modal.component'
      ).then(m => m.LaunchDeckCardModalComponent),
    loadModule: () =>
      import(
        'app/back-to-work/launch-deck/launch-deck-card-modal/launch-deck-card-modal.module'
      ).then(m => m.LaunchDeckCardModalModule),
  },
  BidPackPurchaseModal: {
    loadComponent: () =>
      import(
        'app/bid-packs/bid-pack-purchase-modal/bid-pack-purchase-modal.component'
      ).then(m => m.BidPackPurchaseModalComponent),
    loadModule: () =>
      import(
        'app/bid-packs/bid-pack-purchase-modal/bid-pack-purchase-modal.module'
      ).then(m => m.BidPackPurchaseModalModule),
  },
  CallWindowDevicesModal: {
    loadComponent: () =>
      import(
        'app/call-window/devices-modal/call-window-devices-modal.component'
      ).then(m => m.CallWindowDevicesModalComponent),
    loadModule: () =>
      import(
        'app/call-window/devices-modal/call-window-devices-modal.module'
      ).then(m => m.CallWindowDevicesModalModule),
  },
  CallWindowPreawardModal: {
    loadComponent: () =>
      import(
        'app/call-window/preaward-modal/call-window-preaward-modal.component'
      ).then(m => m.CallWindowPreawardModalComponent),
    loadModule: () =>
      import(
        'app/call-window/preaward-modal/call-window-preaward-modal.module'
      ).then(m => m.CallWindowPreawardModalModule),
  },
  CallWindowRecordedModal: {
    loadComponent: () =>
      import(
        'app/call-window/recorded-modal/call-window-recorded-modal.component'
      ).then(m => m.CallWindowRecordedModalComponent),
    loadModule: () =>
      import(
        'app/call-window/recorded-modal/call-window-recorded-modal.module'
      ).then(m => m.CallWindowRecordedModalModule),
  },
  VideochatErrorModal: {
    loadComponent: () =>
      import(
        'app/call-window/videochat-error-modal/videochat-error-modal.component'
      ).then(m => m.VideochatErrorModalComponent),
    loadModule: () =>
      import(
        'app/call-window/videochat-error-modal/videochat-error-modal.module'
      ).then(m => m.VideochatErrorModalModule),
  },
  ConnectProjectWorkspaceModal: {
    loadComponent: () =>
      import(
        'app/check-ins/connect-project-workspace-modal/connect-project-workspace-modal.component'
      ).then(m => m.ConnectProjectWorkspaceModalComponent),
    loadModule: () =>
      import(
        'app/check-ins/connect-project-workspace-modal/connect-project-workspace-modal.module'
      ).then(m => m.ConnectProjectWorkspaceModalModule),
  },
  CommentDeleteModal: {
    loadComponent: () =>
      import(
        'app/comment-feed/comment-delete-modal/comment-delete-modal.component'
      ).then(m => m.CommentDeleteModalComponent),
    loadModule: () =>
      import(
        'app/comment-feed/comment-delete-modal/comment-delete-modal.module'
      ).then(m => m.CommentDeleteModalModule),
  },
  CommentsAllDeleteModal: {
    loadComponent: () =>
      import(
        'app/comment-feed/comments-all-delete-modal/comments-all-delete-modal.component'
      ).then(m => m.CommentsAllDeleteModalComponent),
    loadModule: () =>
      import(
        'app/comment-feed/comments-all-delete-modal/comments-all-delete-modal.module'
      ).then(m => m.CommentsAllDeleteModalModule),
  },
  ContactSyncModal: {
    loadComponent: () =>
      import('app/contact-sync-modal/contact-sync-modal.component').then(
        m => m.ContactSyncModalComponent,
      ),
    loadModule: () =>
      import('app/contact-sync-modal/contact-sync-modal.module').then(
        m => m.ContactSyncModalModule,
      ),
  },
  ContestAcceptOfferModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-accept-offer-modal/contest-accept-offer-modal.component'
      ).then(m => m.ContestAcceptOfferModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-accept-offer-modal/contest-accept-offer-modal.module'
      ).then(m => m.ContestAcceptOfferModalModule),
  },
  ContestAwardModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-award-modal/contest-award-modal.component'
      ).then(m => m.ContestAwardModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-award-modal/contest-award-modal.module'
      ).then(m => m.ContestAwardModalModule),
  },
  ContestBuyModal: {
    loadComponent: () =>
      import('app/contests/contest-buy-modal/contest-buy-modal.component').then(
        m => m.ContestBuyModalComponent,
      ),
    loadModule: () =>
      import('app/contests/contest-buy-modal/contest-buy-modal.module').then(
        m => m.ContestBuyModalModule,
      ),
  },
  ContestEntryEditSellPriceModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-entry-edit-sell-price-modal/contest-entry-edit-sell-price-modal.component'
      ).then(m => m.ContestEntryEditSellPriceModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-entry-edit-sell-price-modal/contest-entry-edit-sell-price-modal.module'
      ).then(m => m.ContestEntryEditSellPriceModalModule),
  },
  ContestFilePreviewModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-file-preview-modal/contest-file-preview-modal.component'
      ).then(m => m.ContestFilePreviewModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-file-preview-modal/contest-file-preview-modal.module'
      ).then(m => m.ContestFilePreviewModalModule),
  },
  ContestHandoverFilesModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-handover-files-modal/contest-handover-files-modal.component'
      ).then(m => m.ContestHandoverFilesModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-handover-files-modal/contest-handover-files-modal.module'
      ).then(m => m.ContestHandoverFilesModalModule),
  },
  ContestHighlightEntryModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-highlight-entry-modal/contest-highlight-entry-modal.component'
      ).then(m => m.ContestHighlightEntryModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-highlight-entry-modal/contest-highlight-entry-modal.module'
      ).then(m => m.ContestHighlightEntryModalModule),
  },
  ContestInterestedFreelancersModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-interested-freelancers-modal/contest-interested-freelancers-modal.component'
      ).then(m => m.ContestInterestedFreelancersModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-interested-freelancers-modal/contest-interested-freelancers-modal.module'
      ).then(m => m.ContestInterestedFreelancersModalModule),
  },
  ContestMakeOfferModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-make-offer-modal/contest-make-offer-modal.component'
      ).then(m => m.ContestMakeOfferModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-make-offer-modal/contest-make-offer-modal.module'
      ).then(m => m.ContestMakeOfferModalModule),
  },
  ContestMultiAwardModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-multi-award-modal/contest-multi-award-modal.component'
      ).then(m => m.ContestMultiAwardModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-multi-award-modal/contest-multi-award-modal.module'
      ).then(m => m.ContestMultiAwardModalModule),
  },
  ContestReviewDisplayModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-review-display-modal/contest-review-display-modal.component'
      ).then(m => m.ContestReviewDisplayModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-review-display-modal/contest-review-display-modal.module'
      ).then(m => m.ContestReviewDisplayModalModule),
  },
  ContestReviewModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-review-modal/contest-review-modal.component'
      ).then(m => m.ContestReviewModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-review-modal/contest-review-modal.module'
      ).then(m => m.ContestReviewModalModule),
  },
  ContestSubmitEntriesModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-submit-entries-modal/contest-submit-entries-modal.component'
      ).then(m => m.ContestSubmitEntriesModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-submit-entries-modal/contest-submit-entries-modal.module'
      ).then(m => m.ContestSubmitEntriesModalModule),
  },
  ContestSubmitEntryLaterModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-submit-entry-later-modal/contest-submit-entry-later-modal.component'
      ).then(m => m.ContestSubmitEntryLaterModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-submit-entry-later-modal/contest-submit-entry-later-modal.module'
      ).then(m => m.ContestSubmitEntryLaterModalModule),
  },
  ContestVerificationModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-verification-modal/contest-verification-modal.component'
      ).then(m => m.ContestVerificationModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-verification-modal/contest-verification-modal.module'
      ).then(m => m.ContestVerificationModalModule),
  },
  ContestPollsModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-details-tab/contest-polls/contest-polls-modal/contest-polls-modal.component'
      ).then(m => m.ContestPollsModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-details-tab/contest-polls/contest-polls-modal/contest-polls-modal.module'
      ).then(m => m.ContestPollsModalModule),
  },
  EntryFilterModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-filter-modal/entry-filter-modal.component'
      ).then(m => m.EntryFilterModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-filter-modal/entry-filter-modal.module'
      ).then(m => m.EntryFilterModalModule),
  },
  FullscreenQuickviewModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/fullscreen-quickview-modal.component'
      ).then(m => m.FullscreenQuickviewModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/fullscreen-quickview-modal.module'
      ).then(m => m.FullscreenQuickviewModalModule),
  },
  QuickviewModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/quickview-modal.component'
      ).then(m => m.QuickviewModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/quickview-modal.module'
      ).then(m => m.QuickviewModalModule),
  },
  ContestRubricSectionDeleteModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-judging-tab/contest-rubric-management/contest-rubric-section-delete-modal/contest-rubric-section-delete-modal.component'
      ).then(m => m.ContestRubricSectionDeleteModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-judging-tab/contest-rubric-management/contest-rubric-section-delete-modal/contest-rubric-section-delete-modal.module'
      ).then(m => m.ContestRubricSectionDeleteModalModule),
  },
  ContestCollaborationRevokeModal: {
    loadComponent: () =>
      import(
        'app/contests/contest-view/contest-share-tab/contest-collaboration-revoke-modal/contest-collaboration-revoke-modal.component'
      ).then(m => m.ContestCollaborationRevokeModalComponent),
    loadModule: () =>
      import(
        'app/contests/contest-view/contest-share-tab/contest-collaboration-revoke-modal/contest-collaboration-revoke-modal.module'
      ).then(m => m.ContestCollaborationRevokeModalModule),
  },
  ViewAllRehireCardsModal: {
    loadComponent: () =>
      import(
        'app/dashboard/dashboard-rehire-carousel/view-all-rehire-cards-modal/view-all-rehire-cards-modal.component'
      ).then(m => m.ViewAllRehireCardsModalComponent),
    loadModule: () =>
      import(
        'app/dashboard/dashboard-rehire-carousel/view-all-rehire-cards-modal/view-all-rehire-cards-modal.module'
      ).then(m => m.ViewAllRehireCardsModalModule),
  },
  CreateCollectionModal: {
    loadComponent: () =>
      import(
        'app/discover-collections/create-collection-modal/create-collection-modal.component'
      ).then(m => m.CreateCollectionModalComponent),
    loadModule: () =>
      import(
        'app/discover-collections/create-collection-modal/create-collection-modal.module'
      ).then(m => m.CreateCollectionModalModule),
  },
  DeleteCollectionModal: {
    loadComponent: () =>
      import(
        'app/discover-collections/delete-collection-modal/delete-collection-modal.component'
      ).then(m => m.DeleteCollectionModalComponent),
    loadModule: () =>
      import(
        'app/discover-collections/delete-collection-modal/delete-collection-modal.module'
      ).then(m => m.DeleteCollectionModalModule),
  },
  SaveToCollectionModal: {
    loadComponent: () =>
      import(
        'app/discover-collections/save-to-collection-modal/save-to-collection-modal.component'
      ).then(m => m.SaveToCollectionModalComponent),
    loadModule: () =>
      import(
        'app/discover-collections/save-to-collection-modal/save-to-collection-modal.module'
      ).then(m => m.SaveToCollectionModalModule),
  },
  DiscoverManageDeleteModal: {
    loadComponent: () =>
      import(
        'app/discover/discover-manage-portfolio-page/discover-manage-delete-modal/discover-manage-delete-modal.component'
      ).then(m => m.DiscoverManageDeleteModalComponent),
    loadModule: () =>
      import(
        'app/discover/discover-manage-portfolio-page/discover-manage-delete-modal/discover-manage-delete-modal.module'
      ).then(m => m.DiscoverManageDeleteModalModule),
  },
  DiscoverManageSuccessModal: {
    loadComponent: () =>
      import(
        'app/discover/discover-manage-portfolio-page/discover-manage-success-modal/discover-manage-success-modal.component'
      ).then(m => m.DiscoverManageSuccessModalComponent),
    loadModule: () =>
      import(
        'app/discover/discover-manage-portfolio-page/discover-manage-success-modal/discover-manage-success-modal.module'
      ).then(m => m.DiscoverManageSuccessModalModule),
  },
  DiscoverPublishCancelModal: {
    loadComponent: () =>
      import(
        'app/discover/publish/form/cancel-modal/discover-publish-cancel-modal.component'
      ).then(m => m.DiscoverPublishCancelModalComponent),
    loadModule: () =>
      import(
        'app/discover/publish/form/cancel-modal/discover-publish-cancel-modal.module'
      ).then(m => m.DiscoverPublishCancelModalModule),
  },
  ConfirmDeleteFileModal: {
    loadComponent: () =>
      import(
        'app/discover/publish/form/confirm-delete-file-modal/confirm-delete-file-modal.component'
      ).then(m => m.ConfirmDeleteFileModalComponent),
    loadModule: () =>
      import(
        'app/discover/publish/form/confirm-delete-file-modal/confirm-delete-file-modal.module'
      ).then(m => m.ConfirmDeleteFileModalModule),
  },
  DiscoverCropperModal: {
    loadComponent: () =>
      import(
        'app/discover/publish/form/cropper/discover-cropper-modal.component'
      ).then(m => m.DiscoverCropperModalComponent),
    loadModule: () =>
      import(
        'app/discover/publish/form/cropper/discover-cropper-modal.module'
      ).then(m => m.DiscoverCropperModalModule),
  },
  EmailSubscribeModal: {
    loadComponent: () =>
      import(
        'app/email-subscribe/email-subscribe-modal/email-subscribe-modal.component'
      ).then(m => m.EmailSubscribeModalComponent),
    loadModule: () =>
      import(
        'app/email-subscribe/email-subscribe-modal/email-subscribe-modal.module'
      ).then(m => m.EmailSubscribeModalModule),
  },
  ApplicationSuccessfulModal: {
    loadComponent: () =>
      import(
        'app/enterprise-talent-success/application-form-section/application-form/application-successful-modal/application-successful-modal.component'
      ).then(m => m.ApplicationSuccessfulModalComponent),
    loadModule: () =>
      import(
        'app/enterprise-talent-success/application-form-section/application-form/application-successful-modal/application-successful-modal.module'
      ).then(m => m.ApplicationSuccessfulModalModule),
  },
  EnterprisePaymentShareSetupModal: {
    loadComponent: () =>
      import(
        'app/enterprise/enterprise-payment-share-setup-modal/enterprise-payment-share-setup-modal.component'
      ).then(m => m.EnterprisePaymentShareSetupModalComponent),
    loadModule: () =>
      import(
        'app/enterprise/enterprise-payment-share-setup-modal/enterprise-payment-share-setup-modal.module'
      ).then(m => m.EnterprisePaymentShareSetupModalModule),
  },
  ExternalCredentialViewModal: {
    loadComponent: () =>
      import(
        'app/external-credential/external-credential-view-modal/external-credential-view-modal.component'
      ).then(m => m.ExternalCredentialViewModalComponent),
    loadModule: () =>
      import(
        'app/external-credential/external-credential-view-modal/external-credential-view-modal.module'
      ).then(m => m.ExternalCredentialViewModalModule),
  },
  ExternalReferencesShareModal: {
    loadComponent: () =>
      import(
        'app/external-references-share-modal/external-references-share-modal.component'
      ).then(m => m.ExternalReferencesShareModalComponent),
    loadModule: () =>
      import(
        'app/external-references-share-modal/external-references-share-modal.module'
      ).then(m => m.ExternalReferencesShareModalModule),
  },
  RequestProjectFailedModal: {
    loadComponent: () =>
      import(
        'app/field-services-request-modals/request-project-failed-modal/request-project-failed-modal.component'
      ).then(m => m.RequestProjectFailedModalComponent),
    loadModule: () =>
      import(
        'app/field-services-request-modals/request-project-failed-modal/request-project-failed-modal.module'
      ).then(m => m.RequestProjectFailedModalModule),
  },
  RequestProjectModal: {
    loadComponent: () =>
      import(
        'app/field-services-request-modals/request-project-modal/request-project-modal.component'
      ).then(m => m.RequestProjectModalComponent),
    loadModule: () =>
      import(
        'app/field-services-request-modals/request-project-modal/request-project-modal.module'
      ).then(m => m.RequestProjectModalModule),
  },
  FileAttachmentsModal: {
    loadComponent: () =>
      import(
        'app/file-attachments-modal/file-attachments-modal.component'
      ).then(m => m.FileAttachmentsModalComponent),
    loadModule: () =>
      import('app/file-attachments-modal/file-attachments-modal.module').then(
        m => m.FileAttachmentsModalModule,
      ),
  },
  FilesFilterModal: {
    loadComponent: () =>
      import(
        'app/files-body/files-filter-modal/files-filter-modal.component'
      ).then(m => m.FilesFilterModalComponent),
    loadModule: () =>
      import(
        'app/files-body/files-filter-modal/files-filter-modal.module'
      ).then(m => m.FilesFilterModalModule),
  },
  LinkedAccountsConfirmationModal: {
    loadComponent: () =>
      import(
        'app/freelancer-onboarding/freelancer-onboarding-linked-accounts/linked-accounts-confirmation-modal/linked-accounts-confirmation-modal.component'
      ).then(m => m.LinkedAccountsConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/freelancer-onboarding/freelancer-onboarding-linked-accounts/linked-accounts-confirmation-modal/linked-accounts-confirmation-modal.module'
      ).then(m => m.LinkedAccountsConfirmationModalModule),
  },
  FreelancerVerifiedLandingStatusModal: {
    loadComponent: () =>
      import(
        'app/freelancer-verified/freelancer-verified-landing/freelancer-verified-landing-status-modal/freelancer-verified-landing-status-modal.component'
      ).then(m => m.FreelancerVerifiedLandingStatusModalComponent),
    loadModule: () =>
      import(
        'app/freelancer-verified/freelancer-verified-landing/freelancer-verified-landing-status-modal/freelancer-verified-landing-status-modal.module'
      ).then(m => m.FreelancerVerifiedLandingStatusModalModule),
  },
  FreightlancerAboutPageTeamModal: {
    loadComponent: () =>
      import(
        'app/freightlancer/freightlancer-about-page/freightlancer-about-page-team/freightlancer-about-page-team-modal/freightlancer-about-page-team-modal.component'
      ).then(m => m.FreightlancerAboutPageTeamModalComponent),
    loadModule: () =>
      import(
        'app/freightlancer/freightlancer-about-page/freightlancer-about-page-team/freightlancer-about-page-team-modal/freightlancer-about-page-team-modal.module'
      ).then(m => m.FreightlancerAboutPageTeamModalModule),
  },
  FreightlancerMembershipDetailsModal: {
    loadComponent: () =>
      import(
        'app/freightlancer/freightlancer-membership-page/freightlancer-membership-details-modal/freightlancer-membership-details-modal.component'
      ).then(m => m.FreightlancerMembershipDetailsModalComponent),
    loadModule: () =>
      import(
        'app/freightlancer/freightlancer-membership-page/freightlancer-membership-details-modal/freightlancer-membership-details-modal.module'
      ).then(m => m.FreightlancerMembershipDetailsModalModule),
  },
  SubmitDocumentsConfirmModal: {
    loadComponent: () =>
      import(
        'app/freightlancer/verifications/submit-documents-confirm-modal/submit-documents-confirm-modal.component'
      ).then(m => m.SubmitDocumentsConfirmModalComponent),
    loadModule: () =>
      import(
        'app/freightlancer/verifications/submit-documents-confirm-modal/submit-documents-confirm-modal.module'
      ).then(m => m.SubmitDocumentsConfirmModalModule),
  },
  GiveGetEmailModal: {
    loadComponent: () =>
      import(
        'app/give-get-footer/give-get-email-modal/give-get-email-modal.component'
      ).then(m => m.GiveGetEmailModalComponent),
    loadModule: () =>
      import(
        'app/give-get-footer/give-get-email-modal/give-get-email-modal.module'
      ).then(m => m.GiveGetEmailModalModule),
  },
  GlobalfleetModal: {
    loadComponent: () =>
      import(
        'app/globalfleet/globalfleet-modal/globalfleet-modal.component'
      ).then(m => m.GlobalfleetModalComponent),
    loadModule: () =>
      import('app/globalfleet/globalfleet-modal/globalfleet-modal.module').then(
        m => m.GlobalfleetModalModule,
      ),
  },
  GroupCheckInPostEventModal: {
    loadComponent: () =>
      import(
        'app/groups/group-page/group-pages/group-check-in-post-event-modal/group-check-in-post-event-modal.component'
      ).then(m => m.GroupCheckInPostEventModalComponent),
    loadModule: () =>
      import(
        'app/groups/group-page/group-pages/group-check-in-post-event-modal/group-check-in-post-event-modal.module'
      ).then(m => m.GroupCheckInPostEventModalModule),
  },
  WorkspaceOnboardingModal: {
    loadComponent: () =>
      import(
        'app/groups/group-page/workspace-onboarding-modal/workspace-onboarding-modal.component'
      ).then(m => m.WorkspaceOnboardingModalComponent),
    loadModule: () =>
      import(
        'app/groups/group-page/workspace-onboarding-modal/workspace-onboarding-modal.module'
      ).then(m => m.WorkspaceOnboardingModalModule),
  },
  CreateNewGroupModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/create-new-group/create-new-group-modal/create-new-group-modal.component'
      ).then(m => m.CreateNewGroupModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/create-new-group/create-new-group-modal/create-new-group-modal.module'
      ).then(m => m.CreateNewGroupModalModule),
  },
  FeedDeleteModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/feed-delete-modal/feed-delete-modal.component'
      ).then(m => m.FeedDeleteModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/feed-delete-modal/feed-delete-modal.module'
      ).then(m => m.FeedDeleteModalModule),
  },
  FeedsAllDeleteModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/feeds-all-delete-modal/feeds-all-delete-modal.component'
      ).then(m => m.FeedsAllDeleteModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/feeds-all-delete-modal/feeds-all-delete-modal.module'
      ).then(m => m.FeedsAllDeleteModalModule),
  },
  GroupContentRemoveModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/group-content-remove-modal/group-content-remove-modal.component'
      ).then(m => m.GroupContentRemoveModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/group-content-remove-modal/group-content-remove-modal.module'
      ).then(m => m.GroupContentRemoveModalModule),
  },
  GroupDetailsEditModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/group-details-edit-modal/group-details-edit-modal.component'
      ).then(m => m.GroupDetailsEditModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/group-details-edit-modal/group-details-edit-modal.module'
      ).then(m => m.GroupDetailsEditModalModule),
  },
  GroupLeaveModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/group-leave-modal/group-leave-modal.component'
      ).then(m => m.GroupLeaveModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/group-leave-modal/group-leave-modal.module'
      ).then(m => m.GroupLeaveModalModule),
  },
  GroupRemoveUserModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/group-remove-user-modal/group-remove-user-modal.component'
      ).then(m => m.GroupRemoveUserModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/group-remove-user-modal/group-remove-user-modal.module'
      ).then(m => m.GroupRemoveUserModalModule),
  },
  ProjectGroupRemoveModal: {
    loadComponent: () =>
      import(
        'app/groups/groups-common/project-group-remove-modal/project-group-remove-modal.component'
      ).then(m => m.ProjectGroupRemoveModalComponent),
    loadModule: () =>
      import(
        'app/groups/groups-common/project-group-remove-modal/project-group-remove-modal.module'
      ).then(m => m.ProjectGroupRemoveModalModule),
  },
  HireMeHourlyConfirmationModal: {
    loadComponent: () =>
      import(
        'app/hire-me/hire-me-hourly-confirmation-modal/hire-me-hourly-confirmation-modal.component'
      ).then(m => m.HireMeHourlyConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/hire-me/hire-me-hourly-confirmation-modal/hire-me-hourly-confirmation-modal.module'
      ).then(m => m.HireMeHourlyConfirmationModalModule),
  },
  HireMePaymentVerifyModal: {
    loadComponent: () =>
      import(
        'app/hire-me/hire-me-payment-verify-modal/hire-me-payment-verify-modal.component'
      ).then(m => m.HireMePaymentVerifyModalComponent),
    loadModule: () =>
      import(
        'app/hire-me/hire-me-payment-verify-modal/hire-me-payment-verify-modal.module'
      ).then(m => m.HireMePaymentVerifyModalModule),
  },
  HireMeWebappModal: {
    loadComponent: () =>
      import(
        'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component'
      ).then(m => m.HireMeWebappModalComponent),
    loadModule: () =>
      import(
        'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.module'
      ).then(m => m.HireMeWebappModalModule),
  },
  CreateInvitationModal: {
    loadComponent: () =>
      import(
        'app/invitation/create-invitation-modal/create-invitation-modal.component'
      ).then(m => m.CreateInvitationModalComponent),
    loadModule: () =>
      import(
        'app/invitation/create-invitation-modal/create-invitation-modal.module'
      ).then(m => m.CreateInvitationModalModule),
  },
  DeloitteEmailPreviewModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/deloitte/form/email-preview-modal/deloitte-email-preview-modal.component'
      ).then(m => m.DeloitteEmailPreviewModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/deloitte/form/email-preview-modal/deloitte-email-preview-modal.module'
      ).then(m => m.DeloitteEmailPreviewModalModule),
  },
  ClearJobDescriptionConfirmationModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/clear-job-description-confirmation-modal/clear-job-description-confirmation-modal.component'
      ).then(m => m.ClearJobDescriptionConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/clear-job-description-confirmation-modal/clear-job-description-confirmation-modal.module'
      ).then(m => m.ClearJobDescriptionConfirmationModalModule),
  },
  CustomBudgetModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/contest/budget/custom-budget-modal/custom-budget-modal.component'
      ).then(m => m.CustomBudgetModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/contest/budget/custom-budget-modal/custom-budget-modal.module'
      ).then(m => m.CustomBudgetModalModule),
  },
  ContestDurationOtherModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/contest/duration/contest-duration-other-modal/contest-duration-other-modal.component'
      ).then(m => m.ContestDurationOtherModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/contest/duration/contest-duration-other-modal/contest-duration-other-modal.module'
      ).then(m => m.ContestDurationOtherModalModule),
  },
  ResetAiChangesConfirmationModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/description/reset-ai-changes-confirmation-modal/reset-ai-changes-confirmation-modal.component'
      ).then(m => m.ResetAiChangesConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/description/reset-ai-changes-confirmation-modal/reset-ai-changes-confirmation-modal.module'
      ).then(m => m.ResetAiChangesConfirmationModalModule),
  },
  JobTypeSwitcherModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/job-type/job-type-switcher-modal/job-type-switcher-modal.component'
      ).then(m => m.JobTypeSwitcherModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/job-type/job-type-switcher-modal/job-type-switcher-modal.module'
      ).then(m => m.JobTypeSwitcherModalModule),
  },
  ThreeQuestionPjpOptOutConfirmationModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/three-question-pjp/three-question-pjp-opt-out-confirmation-modal/three-question-pjp-opt-out-confirmation-modal.component'
      ).then(m => m.ThreeQuestionPjpOptOutConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/three-question-pjp/three-question-pjp-opt-out-confirmation-modal/three-question-pjp-opt-out-confirmation-modal.module'
      ).then(m => m.ThreeQuestionPjpOptOutConfirmationModalModule),
  },
  EditTitleConfirmationModal: {
    loadComponent: () =>
      import(
        'app/jobs/job-post/form/title/edit-title-confirmation-modal/edit-title-confirmation-modal.component'
      ).then(m => m.EditTitleConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/jobs/job-post/form/title/edit-title-confirmation-modal/edit-title-confirmation-modal.module'
      ).then(m => m.EditTitleConfirmationModalModule),
  },
  LoginSignupModal: {
    loadComponent: () =>
      import(
        'app/login-signup/login-signup-modal/login-signup-modal.component'
      ).then(m => m.LoginSignupModalComponent),
    loadModule: () =>
      import(
        'app/login-signup/login-signup-modal/login-signup-modal.module'
      ).then(m => m.LoginSignupModalModule),
  },
  ManageFilterModal: {
    loadComponent: () =>
      import(
        'app/manage/shared/manage-top-nav/manage-filter-modal/manage-filter-modal.component'
      ).then(m => m.ManageFilterModalComponent),
    loadModule: () =>
      import(
        'app/manage/shared/manage-top-nav/manage-filter-modal/manage-filter-modal.module'
      ).then(m => m.ManageFilterModalModule),
  },
  WorkProjectActionsModal: {
    loadComponent: () =>
      import(
        'app/manage/work/projects/work-project-actions/work-project-actions-modal/work-project-actions-modal.component'
      ).then(m => m.WorkProjectActionsModalComponent),
    loadModule: () =>
      import(
        'app/manage/work/projects/work-project-actions/work-project-actions-modal/work-project-actions-modal.module'
      ).then(m => m.WorkProjectActionsModalModule),
  },
  ServiceOfferingDeleteModal: {
    loadComponent: () =>
      import(
        'app/manage/work/service-offerings/delete-modal/service-offering-delete-modal.component'
      ).then(m => m.ServiceOfferingDeleteModalComponent),
    loadModule: () =>
      import(
        'app/manage/work/service-offerings/delete-modal/service-offering-delete-modal.module'
      ).then(m => m.ServiceOfferingDeleteModalModule),
  },
  ServicesPurchaseModal: {
    loadComponent: () =>
      import(
        'app/manage/work/services/services-purchase-modal/services-purchase-modal.component'
      ).then(m => m.ServicesPurchaseModalComponent),
    loadModule: () =>
      import(
        'app/manage/work/services/services-purchase-modal/services-purchase-modal.module'
      ).then(m => m.ServicesPurchaseModalModule),
  },
  MembershipPackageCtaModal: {
    loadComponent: () =>
      import(
        'app/membership/membership-package-card/membership-package-cta/membership-package-cta-modal/membership-package-cta-modal.component'
      ).then(m => m.MembershipPackageCtaModalComponent),
    loadModule: () =>
      import(
        'app/membership/membership-package-card/membership-package-cta/membership-package-cta-modal/membership-package-cta-modal.module'
      ).then(m => m.MembershipPackageCtaModalModule),
  },
  LoadingModal: {
    loadComponent: () =>
      import('app/membership/trial/loading-modal/loading-modal.component').then(
        m => m.LoadingModalComponent,
      ),
    loadModule: () =>
      import('app/membership/trial/loading-modal/loading-modal.module').then(
        m => m.LoadingModalModule,
      ),
  },
  PaymentVerificationNoticeModal: {
    loadComponent: () =>
      import(
        'app/membership/trial/payment-verification-notice-modal/payment-verification-notice-modal.component'
      ).then(m => m.PaymentVerificationNoticeModalComponent),
    loadModule: () =>
      import(
        'app/membership/trial/payment-verification-notice-modal/payment-verification-notice-modal.module'
      ).then(m => m.PaymentVerificationNoticeModalModule),
  },
  SubscriptionErrorModal: {
    loadComponent: () =>
      import(
        'app/membership/trial/subscription-error-modal/subscription-error-modal.component'
      ).then(m => m.SubscriptionErrorModalComponent),
    loadModule: () =>
      import(
        'app/membership/trial/subscription-error-modal/subscription-error-modal.module'
      ).then(m => m.SubscriptionErrorModalModule),
  },
  TrialSuccessModal: {
    loadComponent: () =>
      import(
        'app/membership/trial/trial-success-modal/trial-success-modal.component'
      ).then(m => m.TrialSuccessModalComponent),
    loadModule: () =>
      import(
        'app/membership/trial/trial-success-modal/trial-success-modal.module'
      ).then(m => m.TrialSuccessModalModule),
  },
  CallAlertModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-chat/call-alert-modal/call-alert-modal.component'
      ).then(m => m.CallAlertModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-chat/call-alert-modal/call-alert-modal.module'
      ).then(m => m.CallAlertModalModule),
  },
  MessagingAddPeopleModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-chat/messaging-add-people/messaging-add-people-modal/messaging-add-people-modal.component'
      ).then(m => m.MessagingAddPeopleModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-chat/messaging-add-people/messaging-add-people-modal/messaging-add-people-modal.module'
      ).then(m => m.MessagingAddPeopleModalModule),
  },
  MessagingChatDetailsSettingsBlockModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-chat/messaging-chat-details/messaging-chat-details-settings-redesign/messaging-chat-details-settings-block-modal/messaging-chat-details-settings-block-modal.component'
      ).then(m => m.MessagingChatDetailsSettingsBlockModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-chat/messaging-chat-details/messaging-chat-details-settings-redesign/messaging-chat-details-settings-block-modal/messaging-chat-details-settings-block-modal.module'
      ).then(m => m.MessagingChatDetailsSettingsBlockModalModule),
  },
  MessagingRemoveUserModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-chat/messaging-chat-details/messaging-remove-user/messaging-remove-user-modal/messaging-remove-user-modal.component'
      ).then(m => m.MessagingRemoveUserModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-chat/messaging-chat-details/messaging-remove-user/messaging-remove-user-modal/messaging-remove-user-modal.module'
      ).then(m => m.MessagingRemoveUserModalModule),
  },
  MessagingGroupMembersModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-chat/messaging-group-members/messaging-group-members-modal/messaging-group-members-modal.component'
      ).then(m => m.MessagingGroupMembersModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-chat/messaging-group-members/messaging-group-members-modal/messaging-group-members-modal.module'
      ).then(m => m.MessagingGroupMembersModalModule),
  },
  MessagingFeedbackModal: {
    loadComponent: () =>
      import(
        'app/messaging/messaging-feedback-modal/messaging-feedback-modal.component'
      ).then(m => m.MessagingFeedbackModalComponent),
    loadModule: () =>
      import(
        'app/messaging/messaging-feedback-modal/messaging-feedback-modal.module'
      ).then(m => m.MessagingFeedbackModalModule),
  },
  OperatingAreasEditModal: {
    loadComponent: () =>
      import(
        'app/operating-areas/operating-areas-edit-modal/operating-areas-edit-modal.component'
      ).then(m => m.OperatingAreasEditModalComponent),
    loadModule: () =>
      import(
        'app/operating-areas/operating-areas-edit-modal/operating-areas-edit-modal.module'
      ).then(m => m.OperatingAreasEditModalModule),
  },
  BannerPopUpEditModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/dashboard-banners/banner-pop-up-edit-modal/banner-pop-up-edit-modal.component'
      ).then(m => m.BannerPopUpEditModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/dashboard-banners/banner-pop-up-edit-modal/banner-pop-up-edit-modal.module'
      ).then(m => m.BannerPopUpEditModalModule),
  },
  EmailEditModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/email-management/email-edit-modal/email-edit-modal.component'
      ).then(m => m.EmailEditModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/email-management/email-edit-modal/email-edit-modal.module'
      ).then(m => m.EmailEditModalModule),
  },
  SendTestEmailsModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/email-management/send-test-emails-modal/send-test-emails-modal.component'
      ).then(m => m.SendTestEmailsModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/email-management/send-test-emails-modal/send-test-emails-modal.module'
      ).then(m => m.SendTestEmailsModalModule),
  },
  GroupConfirmDeleteModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-details/group-edit-form/group-confirm-delete-modal/group-confirm-delete-modal.component'
      ).then(m => m.GroupConfirmDeleteModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-details/group-edit-form/group-confirm-delete-modal/group-confirm-delete-modal.module'
      ).then(m => m.GroupConfirmDeleteModalModule),
  },
  GroupsManagementAddMembersModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-add-members-modal/groups-management-add-members-modal.component'
      ).then(m => m.GroupsManagementAddMembersModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-add-members-modal/groups-management-add-members-modal.module'
      ).then(m => m.GroupsManagementAddMembersModalModule),
  },
  GroupsManagementRemoveMemberModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-remove-member-modal/groups-management-remove-member-modal.component'
      ).then(m => m.GroupsManagementRemoveMemberModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-remove-member-modal/groups-management-remove-member-modal.module'
      ).then(m => m.GroupsManagementRemoveMemberModalModule),
  },
  GroupsManagementRemoveMembersModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-remove-members-modal/groups-management-remove-members-modal.component'
      ).then(m => m.GroupsManagementRemoveMembersModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/groups-management/groups-management-members/groups-management-remove-members-modal/groups-management-remove-members-modal.module'
      ).then(m => m.GroupsManagementRemoveMembersModalModule),
  },
  SuperuserCreateGroupModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/groups-management/superuser-create-group-modal/superuser-create-group-modal.component'
      ).then(m => m.SuperuserCreateGroupModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/groups-management/superuser-create-group-modal/superuser-create-group-modal.module'
      ).then(m => m.SuperuserCreateGroupModalModule),
  },
  HpEngineerNotesModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/hp-queue/hp-engineer-notes/hp-engineer-notes-modal.component'
      ).then(m => m.HpEngineerNotesModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/hp-queue/hp-engineer-notes/hp-engineer-notes-modal.module'
      ).then(m => m.HpEngineerNotesModalModule),
  },
  AnalyticsExportModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/reporting-analytics/reporting-analytics-header/analytics-export-modal/analytics-export-modal.component'
      ).then(m => m.AnalyticsExportModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/reporting-analytics/reporting-analytics-header/analytics-export-modal/analytics-export-modal.module'
      ).then(m => m.AnalyticsExportModalModule),
  },
  ProjectNotesModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/shared/project-notes/project-notes-modal.component'
      ).then(m => m.ProjectNotesModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/shared/project-notes/project-notes-modal.module'
      ).then(m => m.ProjectNotesModalModule),
  },
  ChangeUserRoleModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/user-management/change-user-role/change-user-role-modal.component'
      ).then(m => m.ChangeUserRoleModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/user-management/change-user-role/change-user-role-modal.module'
      ).then(m => m.ChangeUserRoleModalModule),
  },
  CloseUserAccountModal: {
    loadComponent: () =>
      import(
        'app/partner-dashboard/user-management/close-user-account/close-user-account-modal.component'
      ).then(m => m.CloseUserAccountModalComponent),
    loadModule: () =>
      import(
        'app/partner-dashboard/user-management/close-user-account/close-user-account-modal.module'
      ).then(m => m.CloseUserAccountModalModule),
  },
  PaymentsOverlay: {
    loadComponent: () =>
      import(
        'app/payments/common/payments-overlay/payments-overlay.component'
      ).then(m => m.PaymentsOverlayComponent),
    loadModule: () =>
      import(
        'app/payments/common/payments-overlay/payments-overlay.module'
      ).then(m => m.PaymentsOverlayModule),
  },
  Adyen3dsModal: {
    loadComponent: () =>
      import('app/payments/payment-3ds-modal/adyen-3ds-modal.component').then(
        m => m.Adyen3dsModalComponent,
      ),
    loadModule: () =>
      import('app/payments/payment-3ds-modal/adyen-3ds-modal.module').then(
        m => m.Adyen3dsModalModule,
      ),
  },
  PaymentShareInterestModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-share-interest-modal/payment-share-interest-modal.component'
      ).then(m => m.PaymentShareInterestModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-share-interest-modal/payment-share-interest-modal.module'
      ).then(m => m.PaymentShareInterestModalModule),
  },
  PaymentShareKycModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-share-kyc/payment-share-kyc-modal.component'
      ).then(m => m.PaymentShareKycModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-share-kyc/payment-share-kyc-modal.module'
      ).then(m => m.PaymentShareKycModalModule),
  },
  PaymentShareMemberModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-share-member-modal/payment-share-member-modal.component'
      ).then(m => m.PaymentShareMemberModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-share-member-modal/payment-share-member-modal.module'
      ).then(m => m.PaymentShareMemberModalModule),
  },
  PaymentShareSetupModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-share-setup-modal/payment-share-setup-modal.component'
      ).then(m => m.PaymentShareSetupModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-share-setup-modal/payment-share-setup-modal.module'
      ).then(m => m.PaymentShareSetupModalModule),
  },
  PaymentShareMemberRemovalConfirmModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-share/payment-share-members/payment-share-member-removal-confirm-modal/payment-share-member-removal-confirm-modal.component'
      ).then(m => m.PaymentShareMemberRemovalConfirmModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-share/payment-share-members/payment-share-member-removal-confirm-modal/payment-share-member-removal-confirm-modal.module'
      ).then(m => m.PaymentShareMemberRemovalConfirmModalModule),
  },
  PaymentVerifyModal: {
    loadComponent: () =>
      import(
        'app/payments/payment-verify/payment-verify-modal/payment-verify-modal.component'
      ).then(m => m.PaymentVerifyModalComponent),
    loadModule: () =>
      import(
        'app/payments/payment-verify/payment-verify-modal/payment-verify-modal.module'
      ).then(m => m.PaymentVerifyModalModule),
  },
  PaymentsModal: {
    loadComponent: () =>
      import(
        'app/payments/payments-deposit/payments-modal/payments-modal.component'
      ).then(m => m.PaymentsModalComponent),
    loadModule: () =>
      import(
        'app/payments/payments-deposit/payments-modal/payments-modal.module'
      ).then(m => m.PaymentsModalModule),
  },
  PayoutVerificationModal: {
    loadComponent: () =>
      import(
        'app/payments/payout/payout-dashboard/verification/payout-verification-modal.component'
      ).then(m => m.PayoutVerificationModalComponent),
    loadModule: () =>
      import(
        'app/payments/payout/payout-dashboard/verification/payout-verification-modal.module'
      ).then(m => m.PayoutVerificationModalModule),
  },
  PortfolioItemAttachmentModal: {
    loadComponent: () =>
      import(
        'app/portfolio-item-page/attachment-modal/portfolio-item-attachment-modal.component'
      ).then(m => m.PortfolioItemAttachmentModalComponent),
    loadModule: () =>
      import(
        'app/portfolio-item-page/attachment-modal/portfolio-item-attachment-modal.module'
      ).then(m => m.PortfolioItemAttachmentModalModule),
  },
  AwardModal: {
    loadComponent: () =>
      import('app/projects/award-modal/award-modal.component').then(
        m => m.AwardModalComponent,
      ),
    loadModule: () =>
      import('app/projects/award-modal/award-modal.module').then(
        m => m.AwardModalModule,
      ),
  },
  BidAwardRevokeModal: {
    loadComponent: () =>
      import(
        'app/projects/bid-award-revoke-modal/bid-award-revoke-modal.component'
      ).then(m => m.BidAwardRevokeModalComponent),
    loadModule: () =>
      import(
        'app/projects/bid-award-revoke-modal/bid-award-revoke-modal.module'
      ).then(m => m.BidAwardRevokeModalModule),
  },
  CloseBiddingModal: {
    loadComponent: () =>
      import(
        'app/projects/close-bidding-modal/close-bidding-modal.component'
      ).then(m => m.CloseBiddingModalComponent),
    loadModule: () =>
      import(
        'app/projects/close-bidding-modal/close-bidding-modal.module'
      ).then(m => m.CloseBiddingModalModule),
  },
  DeloitteAwardModal: {
    loadComponent: () =>
      import(
        'app/projects/deloitte-award-modal/deloitte-award-modal.component'
      ).then(m => m.DeloitteAwardModalComponent),
    loadModule: () =>
      import(
        'app/projects/deloitte-award-modal/deloitte-award-modal.module'
      ).then(m => m.DeloitteAwardModalModule),
  },
  FreightlancerAwardModal: {
    loadComponent: () =>
      import(
        'app/projects/freightlancer-award-modal/freightlancer-award-modal.component'
      ).then(m => m.FreightlancerAwardModalComponent),
    loadModule: () =>
      import(
        'app/projects/freightlancer-award-modal/freightlancer-award-modal.module'
      ).then(m => m.FreightlancerAwardModalModule),
  },
  HourlyAwardModal: {
    loadComponent: () =>
      import(
        'app/projects/hourly-award-modal/hourly-award-modal.component'
      ).then(m => m.HourlyAwardModalComponent),
    loadModule: () =>
      import('app/projects/hourly-award-modal/hourly-award-modal.module').then(
        m => m.HourlyAwardModalModule,
      ),
  },
  InviteModal: {
    loadComponent: () =>
      import('app/projects/invite-modal/invite-modal.component').then(
        m => m.InviteModalComponent,
      ),
    loadModule: () =>
      import('app/projects/invite-modal/invite-modal.module').then(
        m => m.InviteModalModule,
      ),
  },
  MarketingMobileNumberRestrictionModal: {
    loadComponent: () =>
      import(
        'app/projects/marketing-mobile-number-restriction-modal/marketing-mobile-number-restriction-modal.component'
      ).then(m => m.MarketingMobileNumberRestrictionModalComponent),
    loadModule: () =>
      import(
        'app/projects/marketing-mobile-number-restriction-modal/marketing-mobile-number-restriction-modal.module'
      ).then(m => m.MarketingMobileNumberRestrictionModalModule),
  },
  MilestoneCancelRequestModal: {
    loadComponent: () =>
      import(
        'app/projects/milestone-cancel-request-modal/milestone-cancel-request-modal.component'
      ).then(m => m.MilestoneCancelRequestModalComponent),
    loadModule: () =>
      import(
        'app/projects/milestone-cancel-request-modal/milestone-cancel-request-modal.module'
      ).then(m => m.MilestoneCancelRequestModalModule),
  },
  MilestoneCreateModal: {
    loadComponent: () =>
      import(
        'app/projects/milestone-create-modal/milestone-create-modal.component'
      ).then(m => m.MilestoneCreateModalComponent),
    loadModule: () =>
      import(
        'app/projects/milestone-create-modal/milestone-create-modal.module'
      ).then(m => m.MilestoneCreateModalModule),
  },
  ProjectDeleteModal: {
    loadComponent: () =>
      import(
        'app/projects/project-delete-modal/project-delete-modal.component'
      ).then(m => m.ProjectDeleteModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-delete-modal/project-delete-modal.module'
      ).then(m => m.ProjectDeleteModalModule),
  },
  ProjectEndModal: {
    loadComponent: () =>
      import('app/projects/project-end-modal/project-end-modal.component').then(
        m => m.ProjectEndModalComponent,
      ),
    loadModule: () =>
      import('app/projects/project-end-modal/project-end-modal.module').then(
        m => m.ProjectEndModalModule,
      ),
  },
  ProjectFileRenameModal: {
    loadComponent: () =>
      import(
        'app/projects/project-files/project-file-rename-modal/project-file-rename-modal.component'
      ).then(m => m.ProjectFileRenameModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-files/project-file-rename-modal/project-file-rename-modal.module'
      ).then(m => m.ProjectFileRenameModalModule),
  },
  ProjectFileShareModal: {
    loadComponent: () =>
      import(
        'app/projects/project-files/project-file-share-modal/project-file-share-modal.component'
      ).then(m => m.ProjectFileShareModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-files/project-file-share-modal/project-file-share-modal.module'
      ).then(m => m.ProjectFileShareModalModule),
  },
  ProjectFilesPreviewModal: {
    loadComponent: () =>
      import(
        'app/projects/project-files/project-files-preview-modal/project-files-preview-modal.component'
      ).then(m => m.ProjectFilesPreviewModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-files/project-files-preview-modal/project-files-preview-modal.module'
      ).then(m => m.ProjectFilesPreviewModalModule),
  },
  CloseProjectModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/close-project-modal/close-project-modal.component'
      ).then(m => m.CloseProjectModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/close-project-modal/close-project-modal.module'
      ).then(m => m.CloseProjectModalModule),
  },
  FreightlancerUpdatedTermsModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/freightlancer-updated-terms-modal/freightlancer-updated-terms-modal.component'
      ).then(m => m.FreightlancerUpdatedTermsModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/freightlancer-updated-terms-modal/freightlancer-updated-terms-modal.module'
      ).then(m => m.FreightlancerUpdatedTermsModalModule),
  },
  FreightlancerMembershipModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-details/contact-shipper/membership-modal/freightlancer-membership-modal.component'
      ).then(m => m.FreightlancerMembershipModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-details/contact-shipper/membership-modal/freightlancer-membership-modal.module'
      ).then(m => m.FreightlancerMembershipModalModule),
  },
  ConfirmPickupDeliveryModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-tracking/confirm-pickup-delivery-modal/confirm-pickup-delivery-modal.component'
      ).then(m => m.ConfirmPickupDeliveryModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-tracking/confirm-pickup-delivery-modal/confirm-pickup-delivery-modal.module'
      ).then(m => m.ConfirmPickupDeliveryModalModule),
  },
  EditContactMobileModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-tracking/edit-contact-mobile-modal/edit-contact-mobile-modal.component'
      ).then(m => m.EditContactMobileModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/freightlancer/load-view/load-view-tracking/edit-contact-mobile-modal/edit-contact-mobile-modal.module'
      ).then(m => m.EditContactMobileModalModule),
  },
  BidDescriptionUpsellModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/bid-description-upsell-modal/bid-description-upsell-modal.component'
      ).then(m => m.BidDescriptionUpsellModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/bid-description-upsell-modal/bid-description-upsell-modal.module'
      ).then(m => m.BidDescriptionUpsellModalModule),
  },
  BidPitchOnboardingModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/bid-pitch/bid-pitch-onboarding-modal/bid-pitch-onboarding-modal.component'
      ).then(m => m.BidPitchOnboardingModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/bid-pitch/bid-pitch-onboarding-modal/bid-pitch-onboarding-modal.module'
      ).then(m => m.BidPitchOnboardingModalModule),
  },
  DeloitteAdditionalInfoLocationModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/deloitte-additional-info/deloitte-additional-info-location-modal/deloitte-additional-info-location-modal.component'
      ).then(m => m.DeloitteAdditionalInfoLocationModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/deloitte-additional-info/deloitte-additional-info-location-modal/deloitte-additional-info-location-modal.module'
      ).then(m => m.DeloitteAdditionalInfoLocationModalModule),
  },
  ProjectDetailsEditModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/project-details-edit-modal/project-details-edit-modal.component'
      ).then(m => m.ProjectDetailsEditModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/project-details-edit-modal/project-details-edit-modal.module'
      ).then(m => m.ProjectDetailsEditModalModule),
  },
  ProjectTitleEditRequestModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/project-title-edit-request-modal/project-title-edit-request-modal.component'
      ).then(m => m.ProjectTitleEditRequestModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/project-title-edit-request-modal/project-title-edit-request-modal.module'
      ).then(m => m.ProjectTitleEditRequestModalModule),
  },
  UpgradesBidFormModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-details/upgrades-bid-form/modal/upgrades-bid-form-modal.component'
      ).then(m => m.UpgradesBidFormModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-details/upgrades-bid-form/modal/upgrades-bid-form-modal.module'
      ).then(m => m.UpgradesBidFormModalModule),
  },
  ProjectUpgradeModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-employer/project-upgrades/project-upgrade-modal/project-upgrade-modal.component'
      ).then(m => m.ProjectUpgradeModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-employer/project-upgrades/project-upgrade-modal/project-upgrade-modal.module'
      ).then(m => m.ProjectUpgradeModalModule),
  },
  ProjectFileFilterModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-files/project-file-filter-modal.compontent/project-file-filter-modal.component'
      ).then(m => m.ProjectFileFilterModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-files/project-file-filter-modal.compontent/project-file-filter-modal.module'
      ).then(m => m.ProjectFileFilterModalModule),
  },
  HpProjectReportProblemModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-header/project-view-tabs/hp-project-report-problem/hp-project-report-problem-modal.component'
      ).then(m => m.HpProjectReportProblemModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-header/project-view-tabs/hp-project-report-problem/hp-project-report-problem-modal.module'
      ).then(m => m.HpProjectReportProblemModalModule),
  },
  BulkMilestoneConfirmDeleteModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/payments-summary/milestone-area/milestone-create/bulk-milestone-confirm-delete-modal/bulk-milestone-confirm-delete-modal.component'
      ).then(m => m.BulkMilestoneConfirmDeleteModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/payments-summary/milestone-area/milestone-create/bulk-milestone-confirm-delete-modal/bulk-milestone-confirm-delete-modal.module'
      ).then(m => m.BulkMilestoneConfirmDeleteModalModule),
  },
  SubscriptionConfirmationModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/payments-summary/subscription-area/subscription-confirmation-modal.component'
      ).then(m => m.SubscriptionConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/payments-summary/subscription-area/subscription-confirmation-modal.module'
      ).then(m => m.SubscriptionConfirmationModalModule),
  },
  ProjectManagerSidebarModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/sidebars/project-manager-sidebar/project-manager-sidebar-modal/project-manager-sidebar-modal.component'
      ).then(m => m.ProjectManagerSidebarModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/sidebars/project-manager-sidebar/project-manager-sidebar-modal/project-manager-sidebar-modal.module'
      ).then(m => m.ProjectManagerSidebarModalModule),
  },
  EndProjectConfirmationModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/end-project-confirmation-modal/end-project-confirmation-modal.component'
      ).then(m => m.EndProjectConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/end-project-confirmation-modal/end-project-confirmation-modal.module'
      ).then(m => m.EndProjectConfirmationModalModule),
  },
  FreelancerMilestoneRequestEditModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/freelancer-milestone-request-edit-modal/freelancer-milestone-request-edit-modal.component'
      ).then(m => m.FreelancerMilestoneRequestEditModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/freelancer-milestone-request-edit-modal/freelancer-milestone-request-edit-modal.module'
      ).then(m => m.FreelancerMilestoneRequestEditModalModule),
  },
  RejectProjectModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/reject-project-modal/reject-project-modal.component'
      ).then(m => m.RejectProjectModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/reject-project-modal/reject-project-modal.module'
      ).then(m => m.RejectProjectModalModule),
  },
  MilestoneReleaseModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/milestone-release-modal/milestone-release-modal.component'
      ).then(m => m.MilestoneReleaseModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/milestone-release-modal/milestone-release-modal.module'
      ).then(m => m.MilestoneReleaseModalModule),
  },
  ProjectEndBillingModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/project-end-billing-modal/project-end-billing-modal.component'
      ).then(m => m.ProjectEndBillingModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/project-end-billing-modal/project-end-billing-modal.module'
      ).then(m => m.ProjectEndBillingModalModule),
  },
  InitialDepositRefundModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-payments/user-payments-summary/initial-deposit-refund-modal/initial-deposit-refund-modal.component'
      ).then(m => m.InitialDepositRefundModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-payments/user-payments-summary/initial-deposit-refund-modal/initial-deposit-refund-modal.module'
      ).then(m => m.InitialDepositRefundModalModule),
  },
  BidMoreFiltersModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list-filtering-wrapper/bid-list-filters/bid-more-filters-modal/bid-more-filters-modal.component'
      ).then(m => m.BidMoreFiltersModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list-filtering-wrapper/bid-list-filters/bid-more-filters-modal/bid-more-filters-modal.module'
      ).then(m => m.BidMoreFiltersModalModule),
  },
  BidRetractModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list/bid-retract-modal/bid-retract-modal.component'
      ).then(m => m.BidRetractModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list/bid-retract-modal/bid-retract-modal.module'
      ).then(m => m.BidRetractModalModule),
  },
  InviteToBidModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-proposals/project-proposals-sidebar/waiting-screen-checklist/invite-to-bid-modal/invite-to-bid-modal.component'
      ).then(m => m.InviteToBidModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-proposals/project-proposals-sidebar/waiting-screen-checklist/invite-to-bid-modal/invite-to-bid-modal.module'
      ).then(m => m.InviteToBidModalModule),
  },
  CancelQuotationRevisionConfirmationModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-quotation/freelancer-quotation-area/edit-approved-quotation/cancel-quotation-revision-confirmation-modal/cancel-quotation-revision-confirmation-modal.component'
      ).then(m => m.CancelQuotationRevisionConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-quotation/freelancer-quotation-area/edit-approved-quotation/cancel-quotation-revision-confirmation-modal/cancel-quotation-revision-confirmation-modal.module'
      ).then(m => m.CancelQuotationRevisionConfirmationModalModule),
  },
  QuotationAddFundsModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-quotation/quotation-add-funds/quotation-add-funds-modal/quotation-add-funds-modal.component'
      ).then(m => m.QuotationAddFundsModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-quotation/quotation-add-funds/quotation-add-funds-modal/quotation-add-funds-modal.module'
      ).then(m => m.QuotationAddFundsModalModule),
  },
  EmployerNewRehireProjectModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/employer-new-rehire-project-modal/employer-new-rehire-project-modal.component'
      ).then(m => m.EmployerNewRehireProjectModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/employer-new-rehire-project-modal/employer-new-rehire-project-modal.module'
      ).then(m => m.EmployerNewRehireProjectModalModule),
  },
  EmployerReviewFormModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/employer-review-form-modal/employer-review-form-modal.component'
      ).then(m => m.EmployerReviewFormModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/employer-review-form-modal/employer-review-form-modal.module'
      ).then(m => m.EmployerReviewFormModalModule),
  },
  FreelancerReviewFormModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/freelancer-review-form-modal/freelancer-review-form-modal.component'
      ).then(m => m.FreelancerReviewFormModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/freelancer-review-form-modal/freelancer-review-form-modal.module'
      ).then(m => m.FreelancerReviewFormModalModule),
  },
  ProjectCollaborationRevokeModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-share/project-collaboration-revoke-modal/project-collaboration-revoke-modal.component'
      ).then(m => m.ProjectCollaborationRevokeModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-share/project-collaboration-revoke-modal/project-collaboration-revoke-modal.module'
      ).then(m => m.ProjectCollaborationRevokeModalModule),
  },
  ProjectShareManagementModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-share/project-share-management-modal/project-share-management-modal.component'
      ).then(m => m.ProjectShareManagementModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-share/project-share-management-modal/project-share-management-modal.module'
      ).then(m => m.ProjectShareManagementModalModule),
  },
  CreateMilestoneFromInvoiceModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-tracking/create-milestone-from-invoice-modal/create-milestone-from-invoice-modal.component'
      ).then(m => m.CreateMilestoneFromInvoiceModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-tracking/create-milestone-from-invoice-modal/create-milestone-from-invoice-modal.module'
      ).then(m => m.CreateMilestoneFromInvoiceModalModule),
  },
  DeleteTimeTrackingSessionModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-tracking/tracked-time-list-view/hourly-sessions-list/hourly-session-item/delete-time-tracking-session-modal/delete-time-tracking-session-modal.component'
      ).then(m => m.DeleteTimeTrackingSessionModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-tracking/tracked-time-list-view/hourly-sessions-list/hourly-session-item/delete-time-tracking-session-modal/delete-time-tracking-session-modal.module'
      ).then(m => m.DeleteTimeTrackingSessionModalModule),
  },
  ProjectViewUpgradesModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/project-view-upgrades/project-view-upgrades-modal.component'
      ).then(m => m.ProjectViewUpgradesModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/project-view-upgrades/project-view-upgrades-modal.module'
      ).then(m => m.ProjectViewUpgradesModalModule),
  },
  PunchViewerModalDeletePunchModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/punch-viewer-modal/punch-viewer-modal-delete-punch-modal/delete-time-tracking-session-modal/punch-viewer-modal-delete-punch-modal.component'
      ).then(m => m.PunchViewerModalDeletePunchModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/punch-viewer-modal/punch-viewer-modal-delete-punch-modal/delete-time-tracking-session-modal/punch-viewer-modal-delete-punch-modal.module'
      ).then(m => m.PunchViewerModalDeletePunchModalModule),
  },
  PunchViewerModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/punch-viewer-modal/punch-viewer-modal.component'
      ).then(m => m.PunchViewerModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/punch-viewer-modal/punch-viewer-modal.module'
      ).then(m => m.PunchViewerModalModule),
  },
  UserPortfolioItemOverlay: {
    loadComponent: () =>
      import(
        'app/projects/project-view/user-profile-information/user-portfolio/user-portfolio-item-overlay/user-portfolio-item-overlay.component'
      ).then(m => m.UserPortfolioItemOverlayComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/user-profile-information/user-portfolio/user-portfolio-item-overlay/user-portfolio-item-overlay.module'
      ).then(m => m.UserPortfolioItemOverlayModule),
  },
  ShowcaseViewerModal: {
    loadComponent: () =>
      import(
        'app/projects/project-view/user-profile-information/user-showcase/showcase-viewer-modal/showcase-viewer-modal.component'
      ).then(m => m.ShowcaseViewerModalComponent),
    loadModule: () =>
      import(
        'app/projects/project-view/user-profile-information/user-showcase/showcase-viewer-modal/showcase-viewer-modal.module'
      ).then(m => m.ShowcaseViewerModalModule),
  },
  QuotationAwardModal: {
    loadComponent: () =>
      import(
        'app/projects/quotation-award-modal/quotation-award-modal.component'
      ).then(m => m.QuotationAwardModalComponent),
    loadModule: () =>
      import(
        'app/projects/quotation-award-modal/quotation-award-modal.module'
      ).then(m => m.QuotationAwardModalModule),
  },
  QuotationViewModal: {
    loadComponent: () =>
      import(
        'app/projects/quotation-view-modal/quotation-view-modal.component'
      ).then(m => m.QuotationViewModalComponent),
    loadModule: () =>
      import(
        'app/projects/quotation-view-modal/quotation-view-modal.module'
      ).then(m => m.QuotationViewModalModule),
  },
  RequestMilestoneModal: {
    loadComponent: () =>
      import(
        'app/projects/request-milestone-modal/request-milestone-modal.component'
      ).then(m => m.RequestMilestoneModalComponent),
    loadModule: () =>
      import(
        'app/projects/request-milestone-modal/request-milestone-modal.module'
      ).then(m => m.RequestMilestoneModalModule),
  },
  TimeTrackingPermissionDeniedModal: {
    loadComponent: () =>
      import(
        'app/projects/time-tracking-permission-denied-modal/time-tracking-permission-denied-modal.component'
      ).then(m => m.TimeTrackingPermissionDeniedModalComponent),
    loadModule: () =>
      import(
        'app/projects/time-tracking-permission-denied-modal/time-tracking-permission-denied-modal.module'
      ).then(m => m.TimeTrackingPermissionDeniedModalModule),
  },
  PromptTwoFaUpsellModal: {
    loadComponent: () =>
      import(
        'app/prompt-two-fa-upsell-modal/prompt-two-fa-upsell-modal.component'
      ).then(m => m.PromptTwoFaUpsellModalComponent),
    loadModule: () =>
      import(
        'app/prompt-two-fa-upsell-modal/prompt-two-fa-upsell-modal.module'
      ).then(m => m.PromptTwoFaUpsellModalModule),
  },
  PrototyperPermissionsModal: {
    loadComponent: () =>
      import(
        'app/prototyper-permissions/prototyper-permissions-modal.component'
      ).then(m => m.PrototyperPermissionsModalComponent),
    loadModule: () =>
      import(
        'app/prototyper-permissions/prototyper-permissions-modal.module'
      ).then(m => m.PrototyperPermissionsModalModule),
  },
  QuotationSharingModal: {
    loadComponent: () =>
      import(
        'app/quotations/quotation-sharing/quotation-sharing-modal.component'
      ).then(m => m.QuotationSharingModalComponent),
    loadModule: () =>
      import(
        'app/quotations/quotation-sharing/quotation-sharing-modal.module'
      ).then(m => m.QuotationSharingModalModule),
  },
  RejectQuotationConfirmationModal: {
    loadComponent: () =>
      import(
        'app/quotations/quotation-view/quotation-view-action-buttons/quotation-view-client-actions/quotation-view-reject-button/reject-quotation-confirmation-modal/reject-quotation-confirmation-modal.component'
      ).then(m => m.RejectQuotationConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/quotations/quotation-view/quotation-view-action-buttons/quotation-view-client-actions/quotation-view-reject-button/reject-quotation-confirmation-modal/reject-quotation-confirmation-modal.module'
      ).then(m => m.RejectQuotationConfirmationModalModule),
  },
  CancelQuotationConfirmationModal: {
    loadComponent: () =>
      import(
        'app/quotations/quotation-view/quotation-view-action-buttons/quotation-view-freelancer-actions/cancel-quotation-confirmation-modal/cancel-quotation-confirmation-modal.component'
      ).then(m => m.CancelQuotationConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/quotations/quotation-view/quotation-view-action-buttons/quotation-view-freelancer-actions/cancel-quotation-confirmation-modal/cancel-quotation-confirmation-modal.module'
      ).then(m => m.CancelQuotationConfirmationModalModule),
  },
  RedLeafSecuritiesApplicationModal: {
    loadComponent: () =>
      import(
        'app/red-leaf-securities/application/application-modal/red-leaf-securities-application-modal.component'
      ).then(m => m.RedLeafSecuritiesApplicationModalComponent),
    loadModule: () =>
      import(
        'app/red-leaf-securities/application/application-modal/red-leaf-securities-application-modal.module'
      ).then(m => m.RedLeafSecuritiesApplicationModalModule),
  },
  GiveGetModal: {
    loadComponent: () =>
      import('app/referrals/give-get-modal/give-get-modal.component').then(
        m => m.GiveGetModalComponent,
      ),
    loadModule: () =>
      import('app/referrals/give-get-modal/give-get-modal.module').then(
        m => m.GiveGetModalModule,
      ),
  },
  GiveGetReferralListModal: {
    loadComponent: () =>
      import(
        'app/referrals/give/give-get-referral-list/give-get-referral-list-modal/give-get-referral-list-modal.component'
      ).then(m => m.GiveGetReferralListModalComponent),
    loadModule: () =>
      import(
        'app/referrals/give/give-get-referral-list/give-get-referral-list-modal/give-get-referral-list-modal.module'
      ).then(m => m.GiveGetReferralListModalModule),
  },
  GiveSeeDetailsModal: {
    loadComponent: () =>
      import(
        'app/referrals/give/give-see-details-modal/give-see-details-modal.component'
      ).then(m => m.GiveSeeDetailsModalComponent),
    loadModule: () =>
      import(
        'app/referrals/give/give-see-details-modal/give-see-details-modal.module'
      ).then(m => m.GiveSeeDetailsModalModule),
  },
  FreightlancerSearchLoadsFiltersModal: {
    loadComponent: () =>
      import(
        'app/search/freightlancer/loads/filters-modal/freightlancer-search-loads-filters-modal.component'
      ).then(m => m.FreightlancerSearchLoadsFiltersModalComponent),
    loadModule: () =>
      import(
        'app/search/freightlancer/loads/filters-modal/freightlancer-search-loads-filters-modal.module'
      ).then(m => m.FreightlancerSearchLoadsFiltersModalModule),
  },
  FreightlancerSearchLoadsSortModal: {
    loadComponent: () =>
      import(
        'app/search/freightlancer/loads/sort-modal/freightlancer-search-loads-sort-modal.component'
      ).then(m => m.FreightlancerSearchLoadsSortModalComponent),
    loadModule: () =>
      import(
        'app/search/freightlancer/loads/sort-modal/freightlancer-search-loads-sort-modal.module'
      ).then(m => m.FreightlancerSearchLoadsSortModalModule),
  },
  SearchAdvancedSearchModal: {
    loadComponent: () =>
      import(
        'app/search/search-advanced/search-advanced-search-modal/search-advanced-search-modal.component'
      ).then(m => m.SearchAdvancedSearchModalComponent),
    loadModule: () =>
      import(
        'app/search/search-advanced/search-advanced-search-modal/search-advanced-search-modal.module'
      ).then(m => m.SearchAdvancedSearchModalModule),
  },
  SearchFiltersModal: {
    loadComponent: () =>
      import(
        'app/search/search-filters-modal/search-filters-modal.component'
      ).then(m => m.SearchFiltersModalComponent),
    loadModule: () =>
      import(
        'app/search/search-filters-modal/search-filters-modal.module'
      ).then(m => m.SearchFiltersModalModule),
  },
  SearchSavedFiltersDeleteModal: {
    loadComponent: () =>
      import(
        'app/search/search-saved-filters/search-saved-filters-delete-modal/search-saved-filters-delete-modal.component'
      ).then(m => m.SearchSavedFiltersDeleteModalComponent),
    loadModule: () =>
      import(
        'app/search/search-saved-filters/search-saved-filters-delete-modal/search-saved-filters-delete-modal.module'
      ).then(m => m.SearchSavedFiltersDeleteModalModule),
  },
  SearchUserAvailabilitiesFiltersModal: {
    loadComponent: () =>
      import(
        'app/search/search-user-availabilities/search-user-availabilities-filters-modal/search-user-availabilities-filters-modal.component'
      ).then(m => m.SearchUserAvailabilitiesFiltersModalComponent),
    loadModule: () =>
      import(
        'app/search/search-user-availabilities/search-user-availabilities-filters-modal/search-user-availabilities-filters-modal.module'
      ).then(m => m.SearchUserAvailabilitiesFiltersModalModule),
  },
  ServiceOfferingsCreateOnboardingModal: {
    loadComponent: () =>
      import(
        'app/service-offerings/service-offerings-create-onboarding-modal/service-offerings-create-onboarding-modal.component'
      ).then(m => m.ServiceOfferingsCreateOnboardingModalComponent),
    loadModule: () =>
      import(
        'app/service-offerings/service-offerings-create-onboarding-modal/service-offerings-create-onboarding-modal.module'
      ).then(m => m.ServiceOfferingsCreateOnboardingModalModule),
  },
  ServiceOfferingsViewEmailVerificationModal: {
    loadComponent: () =>
      import(
        'app/service-offerings/service-offerings-view-email-verification-modal/service-offerings-view-email-verification-modal.component'
      ).then(m => m.ServiceOfferingsViewEmailVerificationModalComponent),
    loadModule: () =>
      import(
        'app/service-offerings/service-offerings-view-email-verification-modal/service-offerings-view-email-verification-modal.module'
      ).then(m => m.ServiceOfferingsViewEmailVerificationModalModule),
  },
  SkillsEditModal: {
    loadComponent: () =>
      import('app/skills-edit-modal/skills-edit-modal.component').then(
        m => m.SkillsEditModalComponent,
      ),
    loadModule: () =>
      import('app/skills-edit-modal/skills-edit-modal.module').then(
        m => m.SkillsEditModalModule,
      ),
  },
  SupportPageArticleFeedbackModal: {
    loadComponent: () =>
      import(
        'app/support-page/support-page-article/support-page-article-feedback-modal/support-page-article-feedback-modal.component'
      ).then(m => m.SupportPageArticleFeedbackModalComponent),
    loadModule: () =>
      import(
        'app/support-page/support-page-article/support-page-article-feedback-modal/support-page-article-feedback-modal.module'
      ).then(m => m.SupportPageArticleFeedbackModalModule),
  },
  SupportPageContactModal: {
    loadComponent: () =>
      import(
        'app/support-page/support-page-contact-modal/support-page-contact-modal.component'
      ).then(m => m.SupportPageContactModalComponent),
    loadModule: () =>
      import(
        'app/support-page/support-page-contact-modal/support-page-contact-modal.module'
      ).then(m => m.SupportPageContactModalModule),
  },
  TaskCreateModal: {
    loadComponent: () =>
      import(
        'app/task-lists/task-lists-common/task-create-modal/task-create-modal.component'
      ).then(m => m.TaskCreateModalComponent),
    loadModule: () =>
      import(
        'app/task-lists/task-lists-common/task-create-modal/task-create-modal.module'
      ).then(m => m.TaskCreateModalModule),
  },
  TaskEditModal: {
    loadComponent: () =>
      import(
        'app/task-lists/task-lists-common/task-edit-modal/task-edit-modal.component'
      ).then(m => m.TaskEditModalComponent),
    loadModule: () =>
      import(
        'app/task-lists/task-lists-common/task-edit-modal/task-edit-modal.module'
      ).then(m => m.TaskEditModalModule),
  },
  TaskGroupSaveModal: {
    loadComponent: () =>
      import(
        'app/task-lists/task-lists-common/task-group-save-modal/task-group-save-modal.component'
      ).then(m => m.TaskGroupSaveModalComponent),
    loadModule: () =>
      import(
        'app/task-lists/task-lists-common/task-group-save-modal/task-group-save-modal.module'
      ).then(m => m.TaskGroupSaveModalModule),
  },
  TaskListPageConfirmDeleteModal: {
    loadComponent: () =>
      import(
        'app/task-lists/task-lists-common/task-list-page-confirm-delete-modal/task-list-page-confirm-delete-modal.component'
      ).then(m => m.TaskListPageConfirmDeleteModalComponent),
    loadModule: () =>
      import(
        'app/task-lists/task-lists-common/task-list-page-confirm-delete-modal/task-list-page-confirm-delete-modal.module'
      ).then(m => m.TaskListPageConfirmDeleteModalModule),
  },
  TaskListShareModal: {
    loadComponent: () =>
      import(
        'app/task-lists/task-lists-common/task-list-share-modal/task-list-share-modal.component'
      ).then(m => m.TaskListShareModalComponent),
    loadModule: () =>
      import(
        'app/task-lists/task-lists-common/task-list-share-modal/task-list-share-modal.module'
      ).then(m => m.TaskListShareModalModule),
  },
  TutorialModal: {
    loadComponent: () =>
      import('app/tutorial/home/tutorial-modal/tutorial-modal.component').then(
        m => m.TutorialModalComponent,
      ),
    loadModule: () =>
      import('app/tutorial/home/tutorial-modal/tutorial-modal.module').then(
        m => m.TutorialModalModule,
      ),
  },
  UserListDeloittePractitionerModal: {
    loadComponent: () =>
      import(
        'app/user-lists/user-lists-common/user-list-deloitte-practitioner-modal/user-list-deloitte-practitioner-modal.component'
      ).then(m => m.UserListDeloittePractitionerModalComponent),
    loadModule: () =>
      import(
        'app/user-lists/user-lists-common/user-list-deloitte-practitioner-modal/user-list-deloitte-practitioner-modal.module'
      ).then(m => m.UserListDeloittePractitionerModalModule),
  },
  UserListConfirmationModal: {
    loadComponent: () =>
      import(
        'app/user-lists/user-lists-common/user-list-more-actions/user-list-confirmation-modal/user-list-confirmation-modal.component'
      ).then(m => m.UserListConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/user-lists/user-lists-common/user-list-more-actions/user-list-confirmation-modal/user-list-confirmation-modal.module'
      ).then(m => m.UserListConfirmationModalModule),
  },
  UserListSaveModal: {
    loadComponent: () =>
      import(
        'app/user-lists/user-lists-common/user-list-save/user-list-save-modal.component'
      ).then(m => m.UserListSaveModalComponent),
    loadModule: () =>
      import(
        'app/user-lists/user-lists-common/user-list-save/user-list-save-modal.module'
      ).then(m => m.UserListSaveModalModule),
  },
  UserListsWidgetViewMoreModal: {
    loadComponent: () =>
      import(
        'app/user-lists/user-lists-widgets/user-lists-widget-view-more-modal/user-lists-widget-view-more-modal.component'
      ).then(m => m.UserListsWidgetViewMoreModalComponent),
    loadModule: () =>
      import(
        'app/user-lists/user-lists-widgets/user-lists-widget-view-more-modal/user-lists-widget-view-more-modal.module'
      ).then(m => m.UserListsWidgetViewMoreModalModule),
  },
  UploadCvModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-actions-card/upload-cv-modal/upload-cv-modal.component'
      ).then(m => m.UploadCvModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-actions-card/upload-cv-modal/upload-cv-modal.module'
      ).then(m => m.UploadCvModalModule),
  },
  UserProfileContactModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-contact-modal/user-profile-contact-modal.component'
      ).then(m => m.UserProfileContactModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-contact-modal/user-profile-contact-modal.module'
      ).then(m => m.UserProfileContactModalModule),
  },
  UserProfileExamsModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-exams-redesign/user-profile-exams-modal/user-profile-exams-modal.component'
      ).then(m => m.UserProfileExamsModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-exams-redesign/user-profile-exams-modal/user-profile-exams-modal.module'
      ).then(m => m.UserProfileExamsModalModule),
  },
  UserPortfolioCategoryEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-portfolio-redesign/user-portfolio-category-edit-modal/user-portfolio-category-edit-modal.component'
      ).then(m => m.UserPortfolioCategoryEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-portfolio-redesign/user-portfolio-category-edit-modal/user-portfolio-category-edit-modal.module'
      ).then(m => m.UserPortfolioCategoryEditModalModule),
  },
  UserPortfolioSkillsEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-portfolio/user-portfolio-skills-edit-modal/user-portfolio-skills-edit-modal.component'
      ).then(m => m.UserPortfolioSkillsEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-portfolio/user-portfolio-skills-edit-modal/user-portfolio-skills-edit-modal.module'
      ).then(m => m.UserPortfolioSkillsEditModalModule),
  },
  UserProfileEducationsEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-educations-edit-modal/user-profile-educations-edit-modal.component'
      ).then(m => m.UserProfileEducationsEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-educations-edit-modal/user-profile-educations-edit-modal.module'
      ).then(m => m.UserProfileEducationsEditModalModule),
  },
  UserProfileExperiencesEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-experiences-redesign/user-profile-experiences-edit-modal/user-profile-experiences-edit-modal.component'
      ).then(m => m.UserProfileExperiencesEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-experiences-redesign/user-profile-experiences-edit-modal/user-profile-experiences-edit-modal.module'
      ).then(m => m.UserProfileExperiencesEditModalModule),
  },
  UserProfilePublicationsEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-publications-redesign/user-profile-publications-edit-modal/user-profile-publications-edit-modal.component'
      ).then(m => m.UserProfilePublicationsEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-publications-redesign/user-profile-publications-edit-modal/user-profile-publications-edit-modal.module'
      ).then(m => m.UserProfilePublicationsEditModalModule),
  },
  UserProfileQualificationsEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-qualifications-edit-modal/user-profile-qualifications-edit-modal.component'
      ).then(m => m.UserProfileQualificationsEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-resume/user-profile-qualifications-edit-modal/user-profile-qualifications-edit-modal.module'
      ).then(m => m.UserProfileQualificationsEditModalModule),
  },
  UserProfileReviewsFilterModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-reviews/user-profile-reviews-filter-redesign/user-profile-reviews-filter-modal.component'
      ).then(m => m.UserProfileReviewsFilterModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-reviews/user-profile-reviews-filter-redesign/user-profile-reviews-filter-modal.module'
      ).then(m => m.UserProfileReviewsFilterModalModule),
  },
  UserProfileReviewsModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-reviews/user-profile-reviews-modal.component'
      ).then(m => m.UserProfileReviewsModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-reviews/user-profile-reviews-modal.module'
      ).then(m => m.UserProfileReviewsModalModule),
  },
  CategoryDeleteModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-delete-modal/category-delete-modal.component'
      ).then(m => m.CategoryDeleteModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-delete-modal/category-delete-modal.module'
      ).then(m => m.CategoryDeleteModalModule),
  },
  CategoryEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-edit-modal/category-edit-modal.component'
      ).then(m => m.CategoryEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-edit-modal/category-edit-modal.module'
      ).then(m => m.CategoryEditModalModule),
  },
  CategoryServiceAddModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-service-add-modal/category-service-add-modal.component'
      ).then(m => m.CategoryServiceAddModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-service-add-modal/category-service-add-modal.module'
      ).then(m => m.CategoryServiceAddModalModule),
  },
  CategoryServiceDeleteModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-service-delete-modal/category-service-delete-modal.component'
      ).then(m => m.CategoryServiceDeleteModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/category-service-delete-modal/category-service-delete-modal.module'
      ).then(m => m.CategoryServiceDeleteModalModule),
  },
  EditShopfrontDetailsModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/edit-shopfront-details-modal/edit-shopfront-details-modal.component'
      ).then(m => m.EditShopfrontDetailsModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/edit-shopfront-details-modal/edit-shopfront-details-modal.module'
      ).then(m => m.EditShopfrontDetailsModalModule),
  },
  CreateShopfrontModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-shopfront/user-profile-shopfront-empty-view/create-shopfront-modal/create-shopfront-modal.component'
      ).then(m => m.CreateShopfrontModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-shopfront/user-profile-shopfront-empty-view/create-shopfront-modal/create-shopfront-modal.module'
      ).then(m => m.CreateShopfrontModalModule),
  },
  UserProfileSummaryCreatingModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-creating-modal/user-profile-summary-creating-modal.component'
      ).then(m => m.UserProfileSummaryCreatingModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-creating-modal/user-profile-summary-creating-modal.module'
      ).then(m => m.UserProfileSummaryCreatingModalModule),
  },
  UserProfileSummaryEditModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-edit-modal/user-profile-summary-edit-modal.component'
      ).then(m => m.UserProfileSummaryEditModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-edit-modal/user-profile-summary-edit-modal.module'
      ).then(m => m.UserProfileSummaryEditModalModule),
  },
  UserProfileSummaryStatsModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-stats-modal/user-profile-summary-stats-modal.component'
      ).then(m => m.UserProfileSummaryStatsModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-stats-modal/user-profile-summary-stats-modal.module'
      ).then(m => m.UserProfileSummaryStatsModalModule),
  },
  ProfileVerificationsModal: {
    loadComponent: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-verifications/profile-verifications-modal/profile-verifications-modal.component'
      ).then(m => m.ProfileVerificationsModalComponent),
    loadModule: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-verifications/profile-verifications-modal/profile-verifications-modal.module'
      ).then(m => m.ProfileVerificationsModalModule),
  },
  DeactivateAccountModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/deactivate-account-modal/deactivate-account-modal.component'
      ).then(m => m.DeactivateAccountModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/deactivate-account-modal/deactivate-account-modal.module'
      ).then(m => m.DeactivateAccountModalModule),
  },
  DeleteAccountModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/delete-account-modal/delete-account-modal.component'
      ).then(m => m.DeleteAccountModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/delete-account-modal/delete-account-modal.module'
      ).then(m => m.DeleteAccountModalModule),
  },
  NegativeBalanceWarnModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/negative-balance-warn-modal/negative-balance-warn-modal.component'
      ).then(m => m.NegativeBalanceWarnModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-account/close-account-section/negative-balance-warn-modal/negative-balance-warn-modal.module'
      ).then(m => m.NegativeBalanceWarnModalModule),
  },
  CancelEmailChangeConfirmationModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/cancel-email-change-confirmation-modal/cancel-email-change-confirmation-modal.component'
      ).then(m => m.CancelEmailChangeConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/cancel-email-change-confirmation-modal/cancel-email-change-confirmation-modal.module'
      ).then(m => m.CancelEmailChangeConfirmationModalModule),
  },
  RemoveEmailSubscriberConfirmationModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/remove-email-subscriber-confirmation-modal/remove-email-subscriber-confirmation-modal.component'
      ).then(m => m.RemoveEmailSubscriberConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/remove-email-subscriber-confirmation-modal/remove-email-subscriber-confirmation-modal.module'
      ).then(m => m.RemoveEmailSubscriberConfirmationModalModule),
  },
  VerifyPhoneModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/verify-phone-modal/verify-phone-modal.component'
      ).then(m => m.VerifyPhoneModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-email-and-notifications/verify-phone-modal/verify-phone-modal.module'
      ).then(m => m.VerifyPhoneModalModule),
  },
  LeaveCommunityConfirmationModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-expert-communities/leave-community-confirmation-modal/leave-community-confirmation-modal.component'
      ).then(m => m.LeaveCommunityConfirmationModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-expert-communities/leave-community-confirmation-modal/leave-community-confirmation-modal.module'
      ).then(m => m.LeaveCommunityConfirmationModalModule),
  },
  DeactivateVatNumberModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-financials/eu-tax-info/deactivate-vat-number-modal/deactivate-vat-number-modal.component'
      ).then(m => m.DeactivateVatNumberModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-financials/eu-tax-info/deactivate-vat-number-modal/deactivate-vat-number-modal.module'
      ).then(m => m.DeactivateVatNumberModalModule),
  },
  RemovePaymentMethodModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-financials/payment-methods-section/remove-payment-method-modal/remove-payment-method-modal.component'
      ).then(m => m.RemovePaymentMethodModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-financials/payment-methods-section/remove-payment-method-modal/remove-payment-method-modal.module'
      ).then(m => m.RemovePaymentMethodModalModule),
  },
  RevertTaxOptOutModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-financials/revert-tax-opt-out-modal/revert-tax-opt-out-modal.component'
      ).then(m => m.RevertTaxOptOutModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-financials/revert-tax-opt-out-modal/revert-tax-opt-out-modal.module'
      ).then(m => m.RevertTaxOptOutModalModule),
  },
  DeleteSalesTaxModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-financials/sales-tax-settings/delete-sales-tax-modal/delete-sales-tax-modal.component'
      ).then(m => m.DeleteSalesTaxModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-financials/sales-tax-settings/delete-sales-tax-modal/delete-sales-tax-modal.module'
      ).then(m => m.DeleteSalesTaxModalModule),
  },
  SubscriptionCancelFlowModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-membership/subscription-cancel-flow-modal/subscription-cancel-flow-modal.component'
      ).then(m => m.SubscriptionCancelFlowModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-membership/subscription-cancel-flow-modal/subscription-cancel-flow-modal.module'
      ).then(m => m.SubscriptionCancelFlowModalModule),
  },
  UserSettingsProfileRequestChangeModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-profile/user-settings-profile-request-change-modal/user-settings-profile-request-change-modal.component'
      ).then(m => m.UserSettingsProfileRequestChangeModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-profile/user-settings-profile-request-change-modal/user-settings-profile-request-change-modal.module'
      ).then(m => m.UserSettingsProfileRequestChangeModalModule),
  },
  UserSettingsProfileSetupSecurityPhoneModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-profile/user-settings-profile-setup-security-phone-modal/user-settings-profile-setup-security-phone-modal.component'
      ).then(m => m.UserSettingsProfileSetupSecurityPhoneModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-profile/user-settings-profile-setup-security-phone-modal/user-settings-profile-setup-security-phone-modal.module'
      ).then(m => m.UserSettingsProfileSetupSecurityPhoneModalModule),
  },
  TwoFactorConfirmDisableModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-confirm-disable-modal/two-factor-confirm-disable-modal.component'
      ).then(m => m.TwoFactorConfirmDisableModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-confirm-disable-modal/two-factor-confirm-disable-modal.module'
      ).then(m => m.TwoFactorConfirmDisableModalModule),
  },
  TwoFactorDeliveryMethodsModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-delivery-method-modal/two-factor-delivery-methods-modal.component'
      ).then(m => m.TwoFactorDeliveryMethodsModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-delivery-method-modal/two-factor-delivery-methods-modal.module'
      ).then(m => m.TwoFactorDeliveryMethodsModalModule),
  },
  TwoFactorModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-modal/two-factor-modal.component'
      ).then(m => m.TwoFactorModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-security/two-factor-auth-section/two-factor-modal/two-factor-modal.module'
      ).then(m => m.TwoFactorModalModule),
  },
  DisconnectFacebookModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-trust/verification-methods-section/disconnect-facebook-modal/disconnect-facebook-modal.component'
      ).then(m => m.DisconnectFacebookModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-trust/verification-methods-section/disconnect-facebook-modal/disconnect-facebook-modal.module'
      ).then(m => m.DisconnectFacebookModalModule),
  },
  DisconnectLinkedinModal: {
    loadComponent: () =>
      import(
        'app/user-settings/pages/user-settings-trust/verification-methods-section/disconnect-linkedin-modal/disconnect-linkedin-modal.component'
      ).then(m => m.DisconnectLinkedinModalComponent),
    loadModule: () =>
      import(
        'app/user-settings/pages/user-settings-trust/verification-methods-section/disconnect-linkedin-modal/disconnect-linkedin-modal.module'
      ).then(m => m.DisconnectLinkedinModalModule),
  },
  VehicleTypesEditModal: {
    loadComponent: () =>
      import(
        'app/vehicle-types/vehicle-types-edit-modal/vehicle-types-edit-modal.component'
      ).then(m => m.VehicleTypesEditModalComponent),
    loadModule: () =>
      import(
        'app/vehicle-types/vehicle-types-edit-modal/vehicle-types-edit-modal.module'
      ).then(m => m.VehicleTypesEditModalModule),
  },
  ViolationReportModal: {
    loadComponent: () =>
      import(
        'app/violation-report-modal/violation-report-modal.component'
      ).then(m => m.ViolationReportModalComponent),
    loadModule: () =>
      import('app/violation-report-modal/violation-report-modal.module').then(
        m => m.ViolationReportModalModule,
      ),
  },
};
